<div class="loginpage-container">
  <div class="logo-container">
    <img src="assets/images/feed/deckoratelogowhite.svg" alt="Deckorate Logo" />
    <div class="logo-text">Console <span *ngIf="version">V{{version}}</span></div>
  </div>
  <div class="loginpage-row">
    <div>
      <div class="login-form-container">
        <div>
          <h4>Welcome Back</h4>
          <h5 >Enter your UserName & Password  to login</h5>
        </div>

        <form class="theme-form" [formGroup]="loginForm" (ngSubmit)="onLogin()">

          <!-- USERNAME -->
          <input class="login-input" id="loginUserName" type="text" formControlName="UserName" placeholder="Username (Email)" aria-label="Username (Email)" />
          @if (loginForm.get('UserName')?.touched && loginForm.get('UserName')?.errors?.requiredUserName) {
            <div
              class="text text-danger errormessage">
              Username is required
            </div>
          }
          @if (loginForm.get('UserName')?.touched && loginForm.get('UserName')?.errors?.email) {
            <div class="text text-danger errormessage"
              >
              Enter a valid email address
            </div>
          }

          <!-- PASSWORD -->
          <input class="login-input" id="loginPassword" type="password" formControlName="Password" placeholder="Password" aria-label="Password" />
          @if (loginForm.get('Password')?.touched && loginForm.get('Password')?.errors?.requiredPassword) {
            <div
              class="text text-danger errormessage">
              Password is required
            </div>
          }

          <div class="login-footer"><p><span>Or</span></p></div>

          <!-- ENTERPRISE KEY -->
          <input class="login-input" id="loginEnterpriseKey" type="text" formControlName="EnterpriseKey" placeholder="Enterprise Key" aria-label="Enterprise Key" />
          @if (loginForm.get('EnterpriseKey')?.touched && loginForm.get('EnterpriseKey')?.errors?.requiredEnterprise) {
            <div
              class="text text-danger errormessage">
              Enterprise Key is required
            </div>
          }

          @if (loginForm.get('EnterpriseKey')?.errors?.bothProvided) {
            <div
              class="text text-danger errormessage">
              Please use only one login method at a time
            </div>
          }

          <button class="login-button" type="submit" >LOGIN</button>
          @if (loginUNPWErrorIndicator) {
            <div
              class="text text-danger mt-1">
              {{loginError}}
            </div>
          }

          <!-- <button class="login-button" type="button" (click)="AmplifyLogin()">LOGIN VIA ORGANISATION</button> -->



        </form>

        <!-- <div><br></div> -->

        <!-- <form
        class="theme-form"
        >

        <div>
          <button
            class="login-button"
            mat-raised-button
            color="primary"
            (click)="AmplifyLogin()"
            >
            Login Via Your Organisation
          </button>
        </div>
      </form> -->
      <div class="login-footer">
        <p><span>Powered by</span> <br />The_Loft RRD</p>
      </div>
    </div>
  </div>
  @if (loading) {
    <div class="col-md-12">
      <div class="loader-box loader_overload">
        <div class="loader-25"></div>
      </div>
    </div>
  }

</div>


</div>

<!--

<footer class="footer"></footer> -->
